import {
  ADD_PROFILEPHOTO_START,
  ADD_PROFILEPHOTO_SUCCESS,
  ADD_PROFILEPHOTO_FAILURE,
  ADD_PROFILEPHOTO_RESET,
} from "./actionTypes"

export const addProfilePhotoStart = payload => ({
  type: ADD_PROFILEPHOTO_START,
  payload: payload,
})

export const addProfilePhotoSuccess = payload => ({
  type: ADD_PROFILEPHOTO_SUCCESS,
  payload: payload,
})

export const addProfilePhotoFailure = error => ({
  type: ADD_PROFILEPHOTO_FAILURE,
  payload: error,
})

export const addProfilePhotoReset = () => ({
  type: ADD_PROFILEPHOTO_RESET,
})
